import MenuNames from "../../../constants/Menu/MenuNames.json";
import ZomatoToBlinkitMigration from "../../../views/DriverServiceMigration/ZomatoToBlinkitMigration";
import BlinkitToZomatoMigration from "../../../views/DriverServiceMigration/BlinkitToZomatoMigration";

const DriverServiceMigration = [
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/driver-zomato-to-blinkit-migration",
    component: ZomatoToBlinkitMigration,
    exact: true,
  },
  {
    menuName: MenuNames.SLOT_CAPACITY_UPDATE,
    path: "/driver-blinkit-to-zomato-migration",
    component: BlinkitToZomatoMigration,
    exact: true,
  },
];

export default DriverServiceMigration;
